export default "__VITE_ASSET__DdrxNWxF__"